import React from "react";

import { OnlineStores } from "../../components/reports";
import { WrapperPage } from "../../components/shared/WrapperPage";

export function OnlineStoresPage() {
    return (
        <WrapperPage>
            <OnlineStores />
        </WrapperPage>
    );
}
